import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  TableAdv,
  useFormHandler,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import {
  addJobBoardsCreditHistory,
  addUsersIntegrationAccess,
  getAllIntegrationAccess,
  updateIntegrationAccessStatus,
} from "../../../../redux/slices/setting/settingApi";
import { formatWords2 } from "../../../../utils/stringUtils";
import { getRecruitmentSettingsStart } from "../../../../redux/slices/setting/settingsSlice";
import {
  addCreditHistoryBs,
  addUsersIntegrationAccessBs,
  getAllCreditHistoryBs,
  getAllIntegrationAccessBs,
  getAllIntegrationsBs,
  getSettingsBs,
  updateIntegrationAccessStatusBs,
  updateIntegrationAccessStatusBsMail,
} from "../../../../redux/slices/ats/benchSales/benchSalesApi";
import { getTotalCountApi } from "../../../../redux/slices/totalCount/totalCountApi";
import { getEndOfDay, getStartOfDay } from "../../../../utils/common";
import {
  addCreditHistoryNm,
  addUsersIntegrationAccessNm,
  getAllIntegrationAccessNm,
  updateIntegrationAccessStatusNm,
  updateIntegrationAccessStatusNmMail,
} from "../../../../redux/slices/nonitMarketing/nonitMarketingApi";
const names = ["susan", "patrick", "Jeffery", "Purushottam", "Chris"];

const AddUsersListModel = ({
  isOpen,
  onClose,
  integrationId,
  onValueChange,
  showConnectModal,
  category,
  type,
  selectedModule,
  serviceType,
}) => {
  const [selectedUsers, setSelectedUsers] = useState("");
  const [loading, setLoading] = useState(false);
  const [integrationData, setIntegrationData] = useState([]);
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);
  const { user } = useSelector((state) => state.auth);

  const { users = [] } = useSelector(
    (state) => state.settings?.accessControls?.userTeams || [],
  );

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const totalCount =
    selectedModule === "bs"
      ? value?.addUsersListTableCountBs?.data?.total
      : value?.addUsersListTableCount?.data || 0;
  const intitialformData = {
    assigned: "",
    duration: "",
    credits: "",
    used: "",
    total: "",
  };

  const { formData, errors, handleChange } = useFormHandler(
    intitialformData,
    {},
  );

  const { recruitmentSettings } = useSelector(
    (state) => state.settings?.generalSettings,
  );

  const tableColumn = [
    {
      key: "whoCanUse",
      label: "Who Can Use",
      columnMenu: false,
    },
    {
      key: "credits",
      label: "Credits Till Date",
      columnMenu: false,
      render: (row) => (
        <FormFieldSet
          noTitle
          size="sm"
          placeholder="Enter credits"
          value={row.credits}
          disabled
          onChange={(value) => handleRowChange(row, "credits", value)}
        />
      ),
    },
    {
      key: "duration",
      label: "Duration",
      columnMenu: false,
      render: (row) => (
        <FormFieldSet
          noTitle
          placeholder="Select"
          type="select"
          options={[
            { label: "Per Day", value: 1 },
            { label: "Per Week", value: 2 },
            { label: "Per Month", value: 3 },
            { label: "Fixed", value: 4 },
          ]}
          size="sm"
          value={row.duration}
          disabled
          onChange={(value) => handleRowChange(row, "duration", value)}
        />
      ),
    },
    {
      key: "availableCredits",
      label: "Available Credits",
      columnMenu: false,
    },
    {
      key: "access",
      label: "Access",
      columnMenu: false,
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          // icon={"toggle_on"}
          icon={row.access === 1 ? "toggle_on" : "toggle_off"}
          color={row.access === 1 ? "success" : "black"}
          // color={toggleOn.includes(row.id) ? "success" : "color"}
          // color="black"
          size="sm"
          onClick={() =>
            toggleUsersIntegrationAccess(row.uiid, row.access === 1 ? 2 : 1)
          }
          // onClick={() => handleStatusToggle(row)}
        />
      ),
    },
    category === 3 &&
      type === 1 &&
      recruitmentSettings?.monsterCreditAssign?.type === 2 && {
        key: "creditAutoAssign",
        label: "Auto Assign Credits",
        columnName: false,
        render: (row) => (
          <Button
            type="icon"
            variant="text"
            icon={row.creditAutoAssign === 1 ? "toggle_on" : "toggle_off"}
            color={row.creditAutoAssign === 1 ? "success" : "black"}
            size="sm"
            onClick={() =>
              toggleAutoCreditAssign(
                row.uiid,
                row.creditAutoAssign === 1 ? 2 : 1,
              )
            }
          />
        ),
      },
    {
      key: "status",
      label: "Status",
      columnMenu: false,
      render: (row) => (
        <div className="text-info-500">
          {row.status} {category === 6 ? "Used" : "downloaded"}{" "}
        </div>
      ),
    },
  ];

  const rows = integrationData?.map((item) => ({
    uiid: item.uiid,
    // whoCanUse: item?.userId || "", // If you want names, you need user lookup
    whoCanUse:
      `${formatWords2(item?.userId?.firstName ?? "")} ${formatWords2(item?.userId?.lastName ?? "")}`.trim(),
    credits: item?.accessConfig?.total || "",
    duration: item?.accessConfig?.duration || "",
    availableCredits: item?.accessConfig?.credits || 0, // If exists
    creditAutoAssign: item?.accessConfig?.creditAutoAssign || 2,
    access: item?.status === 1 ? 1 : 2,
    status: item?.accessConfig?.used || 0,
  }));

  // const toggleUsersIntegrationAccess = async (uiid, status) => {
  //   // console.log("uiid, status",uiid, status);

  //       try {
  //         const payload = [{
  //           type: "SET",
  //           value: { status }
  //         }]
  //         setLoading(true);
  //         const updateStatus = selectedModule === "bs" ? (category===11 && (type ===7 || type === 8)?)await updateIntegrationAccessStatusBsMail({ uiid, payload } :updateIntegrationAccessStatusBs )
  //             : await updateIntegrationAccessStatus({ uiid, payload })

  //         if (updateStatus?.data?.data) {
  //           // console.log("update api",updateStatus?.data?.data?.doc)

  //           const doc = updateStatus?.data?.data?.doc;

  //           setIntegrationData(prev =>
  //             prev.map(item =>
  //               item.uiid === doc.uiid
  //                 ? { ...item, status: doc.status }
  //                 : item
  //             )
  //           );
  //           showToast('Integration Access status updated successfully', "success");
  //           setLoading(false);
  //         } else {
  //           showToast("Failed to update Integration Access status", "error");
  //           setLoading(false);
  //         }
  //       } catch (err) {
  //         console.error("Error updating integration Access status:", err);
  //         showToast("Failed to update Integration Access status", "error");
  //         setLoading(false);
  //       }
  //     };

  const toggleUsersIntegrationAccess = async (uiid, status) => {
    try {
      const payload = [{ type: "SET", value: { status } }];

      setLoading(true);

      let updateStatus;

      if (selectedModule === "bs") {
        if (category === 11 && (type === 7 || type === 8)) {
          updateStatus = await updateIntegrationAccessStatusBsMail({
            uiid,
            payload,
          });
        } else {
          updateStatus = await updateIntegrationAccessStatusBs({
            uiid,
            payload,
          });
        }
      } else if(selectedModule === "nm"){
         if (category === 11 && (type === 7 || type === 8)) {
          updateStatus = await updateIntegrationAccessStatusNmMail({
            uiid,
            payload,
          });
        } else {
          updateStatus = await updateIntegrationAccessStatusNm({
            uiid,
            payload,
          });
        }

      }
      else {
        updateStatus = await updateIntegrationAccessStatus({ uiid, payload });
      }

      if (updateStatus?.data?.data) {
        const doc = updateStatus.data.data.doc;

        setIntegrationData((prev) =>
          prev.map((item) =>
            item.uiid === doc.uiid ? { ...item, status: doc.status } : item,
          ),
        );
        showToast("Integration access status updated successfully", "success");
      } else {
        showToast("Failed to update integration access status", "error");
      }
    } catch (err) {
      console.error("Error updating integration access status:", err);
      showToast("Failed to update integration access status", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleRowChange = (row, field, value) => {
    //   setEditedRows(prev => ({
    //   ...prev,
    //   [row.uiid]: {
    //     ...prev[row.uiid],
    //     [field]: value
    //   }
    // }));

    setIntegrationData((prev) =>
      prev.map((item) =>
        item.uiid === row.uiid
          ? {
              ...item,
              accessConfig: {
                ...item.accessConfig,
                ...(field === "credits" && { credits: value }),
                ...(field === "duration" && { duration: value }),
              },
            }
          : item,
      ),
    );
  };

  const handleUpdate = async () => {
    //  try {
    //     setLoading(true);
    //     // map all edited rows to API payloads
    //     const requests = Object.entries(editedRows).map(([uiid, fields]) => ({
    //       uiid, // row uiid
    //       payload: [
    //         {
    //           type: "SET",
    //           value: {
    //             // status: 1,
    //             accessConfig: {
    //               ...(fields.credits && { credits: fields.credits }),
    //               ...(fields.duration && { duration: fields.duration }),
    //             }
    //           }
    //         }
    //       ]
    //     }));
    //     // call API for all edited rows
    //     await Promise.all(requests.map(req => updateIntegrationAccessStatus(req)));
    //     showToast("Integration Access updated successfully", "success");
    //     // clear edited rows after update
    //     setEditedRows({});
    //   } catch (error) {
    //     console.error("Error updating integration access:", error);
    //     showToast("Failed to update Integration Access", "error");
    //   } finally {
    //     setLoading(false);
    //   }
    // console.log("handleRowChange", integrationData)
    // IMPORTANT  DONT DELETE
    // setLoading(true);
    //   try {
    //     const params = {
    //       uiid:20,
    //       payload: [
    //         {
    //           type: "SET",
    //           value: {
    //             status: 1,
    //             accessConfig: {
    //               emails: [
    //                 "abc@gmail.com",
    //                 "xyz@gmail.com"
    //             ]
    //             }
    //           }
    //         }
    //       ]
    //     };
    //     const response = await updateIntegrationAccessStatus(params);
    //     //  SUCCESS CONDITION
    //     if (response?.data) {         // store data
    //       console.log(" Update Integration Access Data:", response?.data);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching updating integration access:", error);
    //   } finally {
    //     setLoading(false);
    //   }
  };

  const toggleAutoCreditAssign = async (uiid, access) => {
    try {
      const payload = [
        {
          type: "SET",
          value: {
            "accessConfig.creditAutoAssign": access,
          },
        },
      ];
      setLoading(true);
      const updateStatus = await updateIntegrationAccessStatus({
        uiid,
        payload,
      });

      if (updateStatus?.data?.data) {
        const doc = updateStatus?.data?.data?.doc;

        setIntegrationData((prev) =>
          prev.map((item) =>
            item.uiid === doc.uiid
              ? {
                  ...item,
                  accessConfig: {
                    ...item?.accessConfig,
                    creditAutoAssign: doc?.accessConfig?.creditAutoAssign,
                  },
                }
              : item,
          ),
        );
        showToast("Credit Auto Assign updated successfully", "success");
        setLoading(false);
      } else {
        showToast("Failed to update Credit Auto Assign status", "error");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error updating Credit Auto Assign status:", err);
      showToast("Failed to update Credit Auto Assign status", "error");
      setLoading(false);
    }
  };

  const mappedRows = mapTableRows(rows, tableColumn);

  useEffect(() => {
    if (!isOpen) return; // run only when modal is open
    if (!integrationId) return;

    const fetchAccessData = async () => {
      setLoading(true);

      try {
        const params = {
          coll:
            selectedModule === "bs" || selectedModule === "nm"
              ? "Integrationaccess"
              : "IntegrationAccess",
          lim: limit,
          pg: page,
          fil: {
            integrationId: {
              type: "NONE",
              value: integrationId,
            },
          },
          ref: "UserId",
          incl: "firstName lastName ",
          // sort: { addedOn: -1 },
        };

        const response =
          selectedModule === "bs"
            ? await getAllIntegrationAccessBs(params)
            : selectedModule === "nm"
              ? await getAllIntegrationAccessNm(params)
              : await getAllIntegrationAccess(params);

        //  SUCCESS CONDITION
        if (response?.data?.data) {
          setIntegrationData(response?.data?.data); // store data
        } else {
          setIntegrationData([]);
          console.warn("No data found");
        }
      } catch (error) {
        console.error("Error fetching integration access:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedModule === "ats") {
      dispatch(
        totalCountStart({
          collection: "integrationaccesss",
          coll: "IntegrationAccess",
          tname: "addUsersListTableCount",
          filters: {
            integrationId: {
              type: "NONE",
              value: integrationId,
            },
          },
          app: "ats",
        }),
      );
    } else if (selectedModule === "bs") {
      dispatch(
        totalCountStart({
          collection: "integrationaccesss",
          coll: "Integrationaccess",
          tname: "addUsersListTableCountBs",
          filters: {
            integrationId: {
              type: "NONE",
              value: integrationId,
            },
          },
          app: "bs",
        }),
      );
    }

    fetchAccessData();
  }, [dispatch, isOpen, integrationId, limit, page, selectedModule]);

  const validateKultaLimits = async () => {
    if (
      !(selectedModule === "bs" && category === 6 && type === 1 && serviceType)
    ) {
      return { allowed: true };
    }

    try {
      const settingsResponse = await getSettingsBs();

      if (!settingsResponse?.data?.data) {
        return { allowed: true };
      }

      const kultailimits = settingsResponse?.data?.data?.kultailimits;

      const totalIntResponse = await getTotalCountApi({
        collection: "integrationbss",
        coll: "Integrationbs",
        filters: {
          category: { type: "NONE", value: category },
          type: { type: "NONE", value: type },
          serviceType: { type: "NONE", value: serviceType },
        },
        app: "bs",
      });

      const totalIntegrations = totalIntResponse?.data?.data?.total || 0;
      if (!totalIntegrations) {
        return { allowed: true };
      }

      const integrationResponse = await getAllIntegrationsBs({
        coll: "Integrationbs",
        fil: JSON.stringify({
          category: { type: "NONE", value: category },
          type: { type: "NONE", value: type },
          serviceType: { type: "NONE", value: serviceType },
        }),
        ret: "uiid",
        lim: totalIntegrations,
      });

      const integrationIds = integrationResponse?.success
        ? integrationResponse?.data?.data?.map((i) => i?.uiid) || []
        : [];

      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfMonth = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        0,
        23,
        59,
        59,
        999,
      );

      if (!integrationIds.length) {
        return { allowed: true };
      }

      const totalCreditHistory = await getTotalCountApi({
        collection: "credithistorys",
        coll: "Credithistory",
        filters: {
          integrationId: { type: "IN", value: integrationIds },
          transactionType: { type: "NONE", value: 1 },
          addedOn: {
            type: "BS_DATE_RANGE",
            value: {
              from: getStartOfDay(startOfMonth),
              to: getEndOfDay(endOfMonth),
            },
          },
        },
        app: "bs",
      });

      const totalCreditRecords = totalCreditHistory?.data?.data?.total || 0;
      let totalCredits = 0;

      if (totalCreditRecords) {
        const creditHistoryResponse = await getAllCreditHistoryBs({
          coll: "Credithistory",
          fil: JSON.stringify({
            integrationId: { type: "IN", value: integrationIds },
            transactionType: { type: "NONE", value: 1 },
            addedOn: {
              type: "BS_DATE_RANGE",
              value: {
                from: getStartOfDay(startOfMonth),
                to: getEndOfDay(endOfMonth),
              },
            },
          }),
          ret: "credits",
          lim: totalCreditRecords,
        });

        if (creditHistoryResponse?.success) {
          totalCredits = (creditHistoryResponse?.data?.data || []).reduce(
            (sum, item) => sum + (item.credits ?? 0),
            0,
          );
        }
      }

      totalCredits += Number(formData.credits || 0);

      if (serviceType === 1 && totalCredits > kultailimits?.parseresume) {
        return {
          allowed: false,
          message: "Maximum parse resume limit reached",
        };
      }

      if (serviceType === 2 && totalCredits > kultailimits?.optimizeresume) {
        return {
          allowed: false,
          message: "Maximum optimize resume limit reached",
        };
      }

      return { allowed: true };
    } catch (error) {
      console.error("Limit validation error:", error);
      return { allowed: false, message: "Credit validation failed" };
    }
  };

  const handleSubmit = async () => {
    // Required field validation
    if (!selectedUsers || selectedUsers.length === 0) {
      showToast("Please select a user!", "error", 2000);
      return;
    }

    if (
      !formData.credits ||
      isNaN(formData.credits) ||
      Number(formData.credits) <= 0
    ) {
      showToast("Please enter valid credits", "error", 2000);
      return;
    }

    setLoading(true);

    const limitCheck = await validateKultaLimits();

    if (!limitCheck.allowed) {
      showToast(limitCheck.message, "error", 3000);
      setLoading(false);
      return;
    }

    // setLoading(false);

    // return;

    const normalizedUserId =
      typeof selectedUsers === "object" && selectedUsers !== null
        ? selectedUsers.value
        : selectedUsers;

    const existingAccess = integrationData.find(
      (item) => item?.userId?.uiid === normalizedUserId,
    );

    //  USER ALREADY EXISTS → ADD CREDITS
    if (existingAccess) {
      try {
        const currentCredits = Number(
          existingAccess?.accessConfig?.credits || 0,
        );
        const currentTotal = Number(
          existingAccess?.accessConfig?.total || currentCredits || 0,
        );
        const addCredits = Number(formData.credits);

        const payload = [
          {
            type: "SET",
            value: {
              accessConfig: {
                credits: currentCredits + addCredits,
                total: currentTotal + addCredits,
              },
            },
          },
        ];

        const updateResponse =
          selectedModule === "bs"
            ? await updateIntegrationAccessStatusBs({
                uiid: existingAccess.uiid,
                payload,
              })
            : selectedModule === "nm"
              ? await updateIntegrationAccessStatusNm({
                  uiid: existingAccess.uiid,
                  payload,
                })
              : await updateIntegrationAccessStatus({
                  uiid: existingAccess.uiid,
                  payload,
                });

        if (updateResponse?.data?.data) {
          const doc = updateResponse?.data?.data?.doc;

          // console.log("doc?.uiid",doc?.uiid);

          const integrationAccessValue = doc?.uiid;

          const historyData = {
            coll:
              selectedModule === "bs"
                ? "CreditHistory"
                : "JobBoardCreditHistory",
            payload: {
              userId: normalizedUserId,
              integrationId: integrationId,
              integrationAccessId: integrationAccessValue,
              transactionType: 1,
              credits: Number(formData.credits),
              addedBy: user?.data?.uiid,
            },
          };

          const historyResponse =
            selectedModule === "bs"
              ? await addCreditHistoryBs(historyData)
              : selectedModule === "nm"
                ? await addCreditHistoryNm(historyData)
                : await addJobBoardsCreditHistory(historyData);

          // console.log("update historyResponse", historyResponse);

          setIntegrationData((prev) =>
            prev.map((item) =>
              item.uiid === doc.uiid
                ? { ...item, accessConfig: doc.accessConfig }
                : item,
            ),
          );

          showToast("Credits updated successfully", "success", 2000);
          onValueChange(true); //  refresh parent
          onClose();
          setSelectedUsers("");
          handleChange("credits", "");
        } else {
          showToast("Failed to update credits", "error", 2000);
        }
      } catch (err) {
        console.error("Error updating credits:", err);
        showToast("Failed to update credits", "error", 2000);
      } finally {
        setLoading(false);
      }
      return;
    }

    //  USER DOES NOT EXIST → CREATE NEW ACCESS
    try {
      const payload = {
        coll: "IntegrationAccess",
        payload: {
          userId: normalizedUserId,
          integrationId,
          accessConfig: {
            credits: Number(formData.credits),
            total: Number(formData.credits),
            used: 0,
            duration: "",
          },
          addedBy: user?.data?.uiid,
        },
      };

      const response =
        selectedModule === "bs"
          ? await addUsersIntegrationAccessBs(payload)
          : selectedModule === "nm"
            ? await addUsersIntegrationAccessNm(payload)
            : await addUsersIntegrationAccess(payload);

      if (response?.data) {
        const integrationAccessValue = response?.data?.data?.uiid;

        const historyData = {
          coll:
            selectedModule === "bs" || selectedModule === "nm"
              ? "CreditHistory"
              : "JobBoardCreditHistory",
          payload: {
            userId: normalizedUserId,
            integrationId: integrationId,
            integrationAccessId: integrationAccessValue,
            transactionType: 1,
            credits: Number(formData.credits),
            addedBy: user?.data?.uiid,
          },
        };

        const historyResponse =
          selectedModule === "bs"
            ? await addCreditHistoryBs(historyData)
            : selectedModule === "nm"
              ? await addCreditHistoryNm(historyData)
              : await addJobBoardsCreditHistory(historyData);

        // console.log("add historyResponse", historyResponse);

        onValueChange(true);
        onClose();
        showToast("Added Users successfully!", "success", 2000);
        setSelectedUsers("");
        handleChange("credits", "");
      }
    } catch (error) {
      console.error("API error:", error);
      showToast("Something went wrong!", "error", 2000);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   dispatch(getRecruitmentSettingsStart({coll: "Setting"}));
  // }, [])

  return (
    <div>
      <Modal
        isOpen={isOpen}
        title="Add List"
        width="max-w-5xl"
        onClose={onClose}
      >
        <div className="grid grid-cols-3 mb-3 items-center gap-2">
          <FormFieldSet
            type={
              selectedModule === "bs"
                ? "getJobBoardUsersBs"
                : selectedModule === "nm"
                  ? "getJobBoardUsersNm"
                  : "getJobBoardUsers"
            }
            showSearch
            placeholder="Select"
            title="Users List"
            // options={options}
            value={selectedUsers}
            // onChange={(v) => setSelectedUsers(v.value)}
            onChange={(value) => setSelectedUsers(value)} // it fixes issue (name converts to uiid when selected after searching) for user dropdowns
          />
          <FormFieldSet
            type="number"
            value={formData.credits}
            title="Assign Credits"
            placeholder="Enter Credits"
            onChange={(value) => handleChange("credits", value)}
          />
          <div className="flex items-end justify-start">
            <Button
              title={"Submit"}
              onClick={handleSubmit}
              size="sm"
              className="w-fit mt-5"
            />
          </div>
        </div>
        <TableAdv
          tableId={`ats_marketplace_adduserslistmodel_${type}_table`}
          columns={tableColumn}
          rows={mappedRows}
          showSlNo={false}
          showCheckbox={false}
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
            fullScreen: true,
            add: [
              {
                component: (
                  <Button title={"Update"} onClick={handleUpdate} size="sm" />
                ),
              },
            ],
          }}
        />
        <Backdrop isOpen={loading}>
          <LogoLoader />
        </Backdrop>
      </Modal>
    </div>
  );
};

export default AddUsersListModel;
